import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Box } from '../Box/index.js';

/* ======================================= */
/**
 * ListChoice is used when selecting options in a list.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/list-choice#usage)
 * - [Props](https://blockparty.endpoint.com/components/list-choice#props)
 * <br />
 *
 */
const ListChoice = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    selected = false,
    isDisabled,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    ref: forwardedRef,
    _disabled: {
      opacity: 0.6,
      cursor: 'not-allowed'
    },
    _hover: {
      bg: 'itemHovered'
    }
    // pseudo-class order matters, active should be last
    // eslint-disable-next-line react/jsx-sort-props
    ,
    _focusVisible: {
      boxShadow: 'focusInset'
    },
    as: "button",
    bg: selected ? 'itemSelected' : 'background',
    border: "none",
    cursor: "pointer"
    // @ts-ignore - disabled prop not captured due to `as` prop
    ,
    disabled: isDisabled,
    fontFamily: "normal",
    outline: "none",
    position: "relative",
    textAlign: "left",
    type: "button",
    width: "100%"
    // eslint-disable-next-line react/jsx-sort-props
    ,
    _active: {
      bg: 'itemSelected'
    }
  }, rest), children);
});

export { ListChoice };
